import React, { useState, useEffect } from "react";
import useApiStable from "../utils/useApiStable";

const PushSendForm = () => {
    const api = useApiStable();
    const [persons, setPersons] = useState([]);
    const [personUuid, setPersonUuid] = useState("");
    const [title, setTitle] = useState("TGT Tennis");
    const [body, setBody] = useState("");
    const [status, setStatus] = useState(null);

    useEffect(() => {
        api.get("/persons").then(setPersons).catch(() => {});
    }, [api]);

    const handleSend = async (e) => {
        e.preventDefault();
        setStatus(null);
        try {
            await api.post("/push/send", { personUuid: personUuid || null, title, body });
            setStatus({ ok: true, msg: "Nachricht gesendet." });
            setBody("");
        } catch {
            setStatus({ ok: false, msg: "Fehler beim Senden." });
        }
    };

    return (
        <div style={{ maxWidth: 480 }}>
            <h3 style={{ marginTop: 0 }}>Push-Benachrichtigung senden</h3>
            <form onSubmit={handleSend}>
                <div style={{ marginBottom: 12 }}>
                    <label style={{ fontSize: 13, color: "#555", display: "block", marginBottom: 4 }}>
                        Empfänger
                    </label>
                    <select
                        value={personUuid}
                        onChange={e => setPersonUuid(e.target.value)}
                        style={{ width: "100%", padding: "8px", border: "1px solid #ddd", borderRadius: 4, fontSize: 14 }}
                    >
                        <option value="">Alle Personen</option>
                        {persons.map(p => (
                            <option key={p.uuid} value={p.uuid}>{p.name}</option>
                        ))}
                    </select>
                </div>
                <div style={{ marginBottom: 12 }}>
                    <label style={{ fontSize: 13, color: "#555", display: "block", marginBottom: 4 }}>
                        Titel
                    </label>
                    <input
                        type="text"
                        value={title}
                        onChange={e => setTitle(e.target.value)}
                        required
                        style={{ width: "100%", padding: "8px", border: "1px solid #ddd", borderRadius: 4, fontSize: 14, boxSizing: "border-box" }}
                    />
                </div>
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontSize: 13, color: "#555", display: "block", marginBottom: 4 }}>
                        Nachricht
                    </label>
                    <textarea
                        value={body}
                        onChange={e => setBody(e.target.value)}
                        required
                        rows={3}
                        style={{ width: "100%", padding: "8px", border: "1px solid #ddd", borderRadius: 4, fontSize: 14, resize: "vertical", boxSizing: "border-box" }}
                    />
                </div>
                <button
                    type="submit"
                    style={{
                        padding: "10px 20px", background: "#4CAF50", color: "#fff",
                        border: "none", borderRadius: 4, cursor: "pointer", fontWeight: "bold",
                    }}
                >
                    Senden
                </button>
            </form>
            {status && (
                <p style={{ marginTop: 12, color: status.ok ? "#2e7d32" : "#e65100" }}>
                    {status.msg}
                </p>
            )}
        </div>
    );
};

export default PushSendForm;
